const faqs = [
  {
    q: '韩国漫画和日本漫画有什么区别？',
    a: '韩国漫画（Manhwa/Webtoon）通常采用纵向滚动阅读方式，画面更注重色彩与光影表现，人物画风偏向写实与唯美。相比日本漫画，韩国漫画在移动端阅读体验更佳，且更新频率通常更高，许多热门连载保持每周更新。本站精选的韩国漫画大全涵盖多种题材，助你快速入门。',
  },
  {
    q: '本站推荐的都是免费韩国漫画吗？',
    a: '本站精选推荐的作品中，相当一部分可以在各大正版平台免费或部分免费阅读。我们整理的免费韩国漫画推荐列表会标注作品的获取渠道与大致付费情况，帮助你找到优质且实惠的阅读选择。韩国漫画在线看的入口信息也会定期更新。',
  },
  {
    q: '韩国漫画排行榜是如何评选的？',
    a: '人气排行综合考量作品的热度指数、读者讨论量、更新频率和口碑评分等多个维度，每周刷新一次。高分推荐则侧重作品的画风质量、剧情完成度和读者长期评价。韩国漫画人气榜力求客观、全面，帮助你筛掉踩雷作品，直达必看好漫。',
  },
  {
    q: '如何第一时间获取最新韩国漫画推荐更新？',
    a: '你可以收藏本页或关注首页的"最新动态"模块，我们每日追踪韩国漫画连载更新情况，及时推送热榜变动、新番上架和专题推荐。韩国漫画必看栏目也会根据季节和话题热度推出主题合集，确保你不会错过任何一部高分佳作。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-600">关于韩国漫画推荐的常见疑问解答</p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5 md:p-6">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">
                <span className="text-primary-500 font-heading mr-2">Q{i + 1}.</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}